import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

// styles
import { Colors, Spacing, Typography } from '_styles';
import { IoChevronBack } from "react-icons/io5";

// redux
import { useSelector, useDispatch, } from 'react-redux';
import { setScreen, selectLastScreen } from '_redux/slices/main-screen/render-screen';
import { setString, setWarning } from '_redux/slices/main-screen/warning-modal';
import { selectLock, setLock } from '_redux/slices/main-screen/screen-lock';

// back button
const Backbutton = (props) => {

    const dispatch = useDispatch();
    const lastpage = useSelector(selectLastScreen)
    const screenLock = useSelector(selectLock);
    const history = useHistory();

    const [hover, setHover] = useState(false);

    const handleClick = () => {
        if (props.onClick) {
            props.onClick()
        }
        if (props.page) {
            history.push('/' + props.page)
            return;
        }

        if (screenLock == true) {
            dispatch(setString(lastpage))
            dispatch(setWarning(true))
        }
        else {
            dispatch(setScreen(lastpage))
        }
    }

    return (
        <IoChevronBack size={28} onClick={handleClick} color='#307FE2' style={{ borderBottomStyle: hover ? 'solid' : 'none', color: Colors.PRM_LIGHT_BLUE, cursor: 'pointer' }} />
    );
}

export default Backbutton;